<div class="anon-layout">
  <router-outlet></router-outlet>
</div>
